import { DataTable } from "@/components/data-table/data-table.tsx";
import { useDataTable } from "@/lib/hooks/use-data-table.ts";
import { useGetMentorships } from "@/lib/api/dashboard.ts";
import { columns } from "@/components/mentorships/columns.tsx";
import { Filters } from "@/components/mentorships/filters.tsx";
import { useDashboardParams } from "@/lib/hooks/admin/use-dashboard-params.ts";
import { useRouter } from "@tanstack/react-router";

export function Mentorships() {
  const router = useRouter();
  const {
    month,
    sortColumn,
    sortDirection,
    status,
    groups,
    mentorId,
    search,
    page,
    per_page,
    last7Days,
  } = useDashboardParams();

  const currentPage = page;
  const pageSize = per_page;

  const { data, isPending } = useGetMentorships({
    month,
    mentorId: mentorId || undefined,
    status: status,
    last7Days,
    search: search || undefined,
    page: currentPage,
    perPage: pageSize,
    groups: groups || undefined,
    sort: sortColumn,
    sortDirection,
  });

  const { table } = useDataTable({
    columns,
    data: data?.mentorships || [],
    defaultPerPage: pageSize,
    pageCount: -1,
    filterFields: [],
  });

  const handlePageChange = (newPageIndex: number) => {
    const newPage = newPageIndex + 1;
    router.navigate({
      to: router.state.location.pathname,
      search: (prev: any) => ({
        ...prev,
        page: newPage,
      }),
    });
  };

  const handlePageSizeChange = (newPageSize: number) => {
    router.navigate({
      to: router.state.location.pathname,
      search: (prev: any) => ({
        ...prev,
        page: 1, // Reset to first page when changing page size
        per_page: newPageSize,
      }),
    });
  };

  return (
    <div>
      <DataTable
        table={table}
        getCanNextPage={() => {
          return data?.hasMore || false;
        }}
        getCanPreviousPage={() => {
          return currentPage > 1;
        }}
        isPending={isPending}
        onRowClick={(row, options) => {
          const url = `/mentorships/${row.mentorship_id}`;
          if (options?.getNavigationUrl) {
            return url;
          }
          router.navigate({
            to: url,
          });
        }}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        getRowClassName={(row) =>
          row.has_open_escalation
            ? "border-t-2 border-b-2 border-red-500 bg-red-50"
            : ""
        }
      >
        <Filters status={status} mentorId={mentorId} />
      </DataTable>
    </div>
  );
}
